import styled from "@emotion/styled";
import { Typography, Avatar,  Row, Col, Grid } from "antd";
import { FC } from "react";
import {
  emailIcon,
  locationCircle,
  locationIcon,
  phoneIcon,
} from "assets/icons";

const { useBreakpoint } = Grid;

const AgentsCard: FC = () => {
  const screens = useBreakpoint();
  return (
    <CardWrapper>
      <Avatar
        src={
          "https://expertphotography.b-cdn.net/wp-content/uploads/2020/08/social-media-profile-photos-3.jpg"
        }
        alt="avatar"
        style={{
          objectFit: "cover",
        }}
        size={60}
        shape="circle"
      />
      <Row style={{ width: "100%" }}>
        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
          <CardContentWrapper>
            <ContentText>
              <TextWrapper>
                <Typography.Text className="text-order-agent-name">
                  {"ตัวแทน: นายสันธาน ลีลาส"}
                </Typography.Text>
                <LocationWrapper>
                  <IconLocation>{locationIcon}</IconLocation>
                  <Typography.Text className="text-order-product-name">
                    {"บางพลี, ราชาเทวะ, สมุทรปราการ"}
                  </Typography.Text>
                </LocationWrapper>
              </TextWrapper>
            </ContentText>
          </CardContentWrapper>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
          <IconGroup
            style={{ justifyContent: screens.xs ? "flex-start" : "flex-end" }}
          >
            <IconWrapper>
              <SpanIcon>{phoneIcon}</SpanIcon>
            </IconWrapper>
            <IconWrapper>
              <SpanIcon>{emailIcon}</SpanIcon>
            </IconWrapper>
            <IconWrapper>
              <SpanIcon>{locationCircle}</SpanIcon>
            </IconWrapper>
          </IconGroup>
        </Col>
      </Row>
    </CardWrapper>
  );
};

export default AgentsCard;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0px 5px 0px 5px;
  background-color: #ffffff;
  border-radius: 0px;
`;

const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 0px 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  width: auto;
  border-radius: 0px;
  cursor: pointer;
`;

const ContentText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-left: 10px;
  margin-top: 10px;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-bottom: 10px;
  margin-left: 10px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const IconLocation = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
`;

const LocationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-align: left;
`;

const IconGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;
